import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _assign from "lodash/assign";
var _excluded = ["text", "type"],
  _excluded2 = ["text", "type", "url"],
  _excluded3 = ["text", "type", "url"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { useEffect, useRef, useState } from 'react';
import { Waypoint } from 'react-waypoint';
import classnames from 'classnames';
import Colors from "../../Color/Colors";
import Browser from "../../Utility/Browser";
import { containsBlockTags } from "../../Utility/Utility";
import { backgroundBgColors } from "../../Background/Background";
import { Button } from "../../Button/Button/Button";
import { Link } from "../../Button/Link/Link";
import { Container } from "../../Container/Container/Container";
import { OfferBanner } from "../../Banner/OfferBanner/OfferBanner";
import { Theme } from "../../Background/Theme/Theme";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Icon } from "../../Icon/Icon/Icon";
import styles from "./PromotionBannerSlice.module.scss";
import { IconButton } from "../../Button/IconButton/IconButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var promotionBannerHorizAlign = ['left', 'right', 'center'];
var keepStickyOn = false;
export var promotionBannerHeadlineTypogs = ['headline5', 'headline6', 'subhead4'];
export var promotionBannerEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3'];
export var promotionBannerButtonTypes = ['link', 'primary', 'secondary'];
export var promotionBannerInsetPosition = ['none', 'top', 'middle', 'bottom'];
export var promotionBannerBgColors = _toConsumableArray(backgroundBgColors);
export var PromotionBannerSlice = function PromotionBannerSlice(_ref) {
  var _offerBanner$text, _offerBanner$popup, _floatingCTA$cta, _stickyBanner$stickyO, _stickyBanner$stickyO2, _stickyBanner$stickyO3, _stickyBanner$stickyO4;
  var _ref$showPromoBanner = _ref.showPromoBanner,
    showPromoBanner = _ref$showPromoBanner === void 0 ? true : _ref$showPromoBanner,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? {
      text: '',
      typog: 'headline5',
      variant: 'default',
      ariaLevel: 2
    } : _ref$headline,
    _ref$offerBanner = _ref.offerBanner,
    offerBanner = _ref$offerBanner === void 0 ? {} : _ref$offerBanner,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {} : _ref$cta,
    icon = _ref.icon,
    _ref$floatingCTA = _ref.floatingCTA,
    floatingCTA = _ref$floatingCTA === void 0 ? {
      text: '',
      typog: 'bodycopy',
      show: false,
      align: 'right',
      cta: {},
      waypointOffset: '-500px',
      icon: icon
    } : _ref$floatingCTA,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: 'eyebrow1',
      variant: 'default'
    } : _ref$eyebrow,
    background = _ref.background,
    _ref$insetPosition = _ref.insetPosition,
    insetPosition = _ref$insetPosition === void 0 ? 'none' : _ref$insetPosition,
    containerBackground = _ref.containerBackground,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'darkBackground' : _ref$theme,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    _ref$stackText = _ref.stackText,
    stackText = _ref$stackText === void 0 ? false : _ref$stackText,
    _ref$stackCTA = _ref.stackCTA,
    stackCTA = _ref$stackCTA === void 0 ? false : _ref$stackCTA,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$slideIntoView = _ref.slideIntoView,
    slideIntoView = _ref$slideIntoView === void 0 ? false : _ref$slideIntoView,
    _ref$stickyBanner = _ref.stickyBanner,
    stickyBanner = _ref$stickyBanner === void 0 ? {
      stickyOfferBanner: {},
      maintainStickyAfterShow: false,
      enableCloseOption: false
    } : _ref$stickyBanner,
    _ref$processJSON = _ref.processJSON,
    processJSON = _ref$processJSON === void 0 ? false : _ref$processJSON;
  var minFloatingCtaWidth = 75;

  // Remove aria level if headline is JSON RichText with heading tags
  var headlineAriaLevel = headline !== null && headline !== void 0 && headline.ariaLevel ? headline === null || headline === void 0 ? void 0 : headline.ariaLevel : 2;
  if (processJSON && headline !== null && headline !== void 0 && headline.text && containsBlockTags(headline === null || headline === void 0 ? void 0 : headline.text)) {
    headlineAriaLevel = undefined;
  }
  var contentRef = useRef(null);
  var _useState = useState(-75),
    _useState2 = _slicedToArray(_useState, 2),
    bottom = _useState2[0],
    setBottom = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    expandFloatingCTA = _useState4[0],
    setExpandFloatingCTA = _useState4[1];
  var _useState5 = useState(minFloatingCtaWidth),
    _useState6 = _slicedToArray(_useState5, 2),
    contentWidth = _useState6[0],
    setContentWidth = _useState6[1];
  var _useState7 = useState(-300),
    _useState8 = _slicedToArray(_useState7, 2),
    stickyOffset = _useState8[0],
    setStickyOffset = _useState8[1];
  var setFloatingCtaWidth = function setFloatingCtaWidth() {
    if (Browser.isBrowser()) {
      setContentWidth(contentRef.current ? contentRef.current.clientWidth : minFloatingCtaWidth);
    }
  };
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    hideDrawer = _useState10[0],
    setHideDrawer = _useState10[1];
  var closeDrawer = function closeDrawer() {
    setHideDrawer(true);
  };
  useEffect(function () {
    if (Browser.isBrowser()) {
      // Component mount.
      setFloatingCtaWidth();
      window.addEventListener('scroll', setFloatingCtaWidth);
      // Component unmount.
      return function () {
        window.removeEventListener('scroll', setFloatingCtaWidth);
      };
    }
  }, [contentWidth]);
  var renderCTA = function renderCTA(cta, asButton) {
    var text = cta.text,
      type = cta.type,
      otherProps = _objectWithoutProperties(cta, _excluded);
    return asButton ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      size: type !== 'link' ? 'medium' : 'large',
      className: styles.ctaButton,
      type: type
    }, otherProps), {}, {
      children: /*#__PURE__*/_jsx(Text, {
        richText: true,
        textElement: "span",
        typog: "bodycopy",
        className: styles.ctaText,
        children: text
      })
    })) : /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
      className: classnames(styles.ctaLink, {
        [styles.darkBackground]: theme === 'darkBackground'
      })
    }, otherProps), {}, {
      children: text
    }));
  };
  var handleBannerWaypointEnter = function handleBannerWaypointEnter() {
    setBottom(-75);
  };
  var handleBannerWaypointLeave = function handleBannerWaypointLeave() {
    setBottom(5);
  };
  var handleButtonWaypointEnter = function handleButtonWaypointEnter() {
    setExpandFloatingCTA(false);
  };
  var handleButtonWaypointLeave = function handleButtonWaypointLeave() {
    setExpandFloatingCTA(true);
  };
  var handleStickyWaypointEnter = function handleStickyWaypointEnter() {
    if (stickyBanner.maintainStickyAfterShow && !keepStickyOn) {
      setStickyOffset(-300);
      keepStickyOn = true;
    } else if (hideDrawer) {
      setStickyOffset(-300);
      keepStickyOn = false;
    } else if (stickyBanner.maintainStickyAfterShow && keepStickyOn && !hideDrawer) {
      setStickyOffset(0);
    } else {
      setStickyOffset(-300);
    }
  };
  var handleStickyWaypointLeave = function handleStickyWaypointLeave() {
    if (!hideDrawer) {
      setStickyOffset(0);
    }
  };
  var renderLink = function renderLink(cta) {
    var url = cta.url,
      newWindow = cta.newWindow,
      accessibilityLabel = cta.accessibilityLabel;
    return /*#__PURE__*/_jsx(Link, {
      "aria-hidden": true,
      tabIndex: -1,
      className: styles.backgroundLink,
      url: url,
      newWindow: newWindow,
      accessibilityLabel: accessibilityLabel
    });
  };
  var renderFloatingCTA = function renderFloatingCTA(icon, iconStyle, innerBackgroundStyle, floatingCTA) {
    var text = floatingCTA.text,
      typog = floatingCTA.typog,
      align = floatingCTA.align,
      innerCTA = floatingCTA.cta;
    var buttonText = innerCTA.text,
      type = innerCTA.type,
      url = innerCTA.url,
      otherProps = _objectWithoutProperties(innerCTA, _excluded2);
    var expandStyle = expandFloatingCTA ? styles.expandFloatingCTA : styles.shrinkFloatingCTA;
    var fullButtonWidth = "".concat(contentWidth + 91, "px");
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        style: _assign({}, innerBackgroundStyle, {
          bottom: bottom,
          width: expandFloatingCTA ? fullButtonWidth : minFloatingCtaWidth
        }),
        className: classnames(styles.floatingCTA, styles[align], {
          [styles.expandFloatingCTA]: expandFloatingCTA
        }),
        children: [(innerCTA === null || innerCTA === void 0 ? void 0 : innerCTA.url) && renderLink(innerCTA), (icon === null || icon === void 0 ? void 0 : icon.show) && /*#__PURE__*/_jsx("div", {
          className: styles.floatingIconWrapper,
          children: /*#__PURE__*/_jsx(Icon, _objectSpread({
            className: iconStyle
          }, icon))
        }), /*#__PURE__*/_jsxs("span", {
          ref: contentRef,
          className: expandStyle,
          children: [/*#__PURE__*/_jsx(Text, {
            richText: true,
            typog: typog,
            children: text
          }), buttonText && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            type: type,
            url: url
          }, otherProps), {}, {
            children: /*#__PURE__*/_jsx(Text, {
              richText: true,
              textElement: "span",
              typog: "bodycopy",
              className: styles.ctaText,
              children: buttonText
            })
          }))]
        })]
      })
    });
  };
  var hasHeadline = !!(headline !== null && headline !== void 0 && headline.text);
  var hasOfferBanner = offerBanner && ((offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$text = offerBanner.text) === null || _offerBanner$text === void 0 ? void 0 : _offerBanner$text.text) || (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$popup = offerBanner.popup) === null || _offerBanner$popup === void 0 ? void 0 : _offerBanner$popup.title));
  var hasCTA = (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url);
  var hasFloatingCTA = (floatingCTA === null || floatingCTA === void 0 ? void 0 : floatingCTA.show) && (floatingCTA === null || floatingCTA === void 0 ? void 0 : (_floatingCTA$cta = floatingCTA.cta) === null || _floatingCTA$cta === void 0 ? void 0 : _floatingCTA$cta.url);
  var hasEyebrow = eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text;
  var hasText = hasHeadline || hasOfferBanner;
  var hasInset = insetPosition !== 'none';
  var hasStickyOfferBanner = (stickyBanner === null || stickyBanner === void 0 ? void 0 : stickyBanner.stickyOfferBanner) && ((stickyBanner === null || stickyBanner === void 0 ? void 0 : (_stickyBanner$stickyO = stickyBanner.stickyOfferBanner) === null || _stickyBanner$stickyO === void 0 ? void 0 : (_stickyBanner$stickyO2 = _stickyBanner$stickyO.text) === null || _stickyBanner$stickyO2 === void 0 ? void 0 : _stickyBanner$stickyO2.text) || (stickyBanner === null || stickyBanner === void 0 ? void 0 : (_stickyBanner$stickyO3 = stickyBanner.stickyOfferBanner) === null || _stickyBanner$stickyO3 === void 0 ? void 0 : (_stickyBanner$stickyO4 = _stickyBanner$stickyO3.popup) === null || _stickyBanner$stickyO4 === void 0 ? void 0 : _stickyBanner$stickyO4.title));
  var containerBackgroundStyle = hasInset && containerBackground !== 'none' ? {
    backgroundColor: containerBackground
  } : null;
  var innerBackgroundStyle = background !== 'none' ? {
    backgroundColor: background
  } : {};
  var outerBackgroundStyle = containerBackgroundStyle ? containerBackgroundStyle : innerBackgroundStyle;
  var iconTheme = theme === 'darkBackground' ? styles.darkBackground : styles.lightBackground;
  var bannerContent = /*#__PURE__*/_jsxs("div", {
    className: classnames(className, {
      [styles.promotionBanner]: true,
      [styles.textCenter]: align === 'center',
      [styles.textLeft]: align === 'left',
      [styles.textStacked]: stackText,
      [styles.textInline]: !stackText,
      [styles.withCta]: hasCTA || !hasCTA && hasFloatingCTA,
      [styles.ctaStacked]: hasCTA && stackCTA,
      [styles.ctaInline]: hasCTA && !stackCTA,
      [styles.noText]: !hasText,
      [styles.withInset]: hasInset,
      [styles.withInsetMiddle]: insetPosition === 'middle',
      [styles.withInsetTop]: insetPosition === 'top',
      [styles.withInsetBottom]: insetPosition === 'bottom',
      [styles.slideIntoView]: slideIntoView
    }),
    "data-e2e-name": "promotionBanner_slice",
    style: outerBackgroundStyle,
    children: [!hasInset && (hasCTA && renderCTA(cta, false) || hasFloatingCTA && renderCTA(floatingCTA.cta, false)), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.innerWrapper,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.col,
          style: innerBackgroundStyle,
          children: [hasInset && (hasCTA && renderCTA(cta, false) || hasFloatingCTA && renderCTA(floatingCTA.cta, false)), /*#__PURE__*/_jsx("div", {
            className: styles.container,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [(icon === null || icon === void 0 ? void 0 : icon.show) && /*#__PURE__*/_jsx("div", {
                className: classnames(styles.iconWrapper, {
                  [styles.iconShake]: slideIntoView
                }),
                style: {
                  minWidth: icon.width
                },
                children: /*#__PURE__*/_jsx(Icon, _objectSpread({
                  className: iconTheme
                }, icon))
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.innerContent,
                children: [hasText && /*#__PURE__*/_jsxs("div", {
                  className: styles.textContainer,
                  children: [hasEyebrow && /*#__PURE__*/_jsx("div", {
                    className: classnames(styles.eyebrow, {
                      [styles.textCenter]: align === 'center'
                    }),
                    children: /*#__PURE__*/_jsx(Text, {
                      richText: true,
                      typog: eyebrow.typog,
                      variant: eyebrow.variant,
                      textElement: "span",
                      children: eyebrow.text
                    })
                  }), hasHeadline && /*#__PURE__*/_jsx(HeadingText, {
                    richText: true,
                    className: classnames(styles.headline, {
                      [styles.mobileHeadlineSix]: headline.typog === 'headline6'
                    }),
                    typog: headline.typog,
                    variant: headline.variant,
                    align: align,
                    ariaLevel: headlineAriaLevel,
                    children: headline === null || headline === void 0 ? void 0 : headline.text
                  }), hasOfferBanner && /*#__PURE__*/_jsx(OfferBanner, _objectSpread({
                    align: align,
                    className: styles.offer,
                    wrapperClassName: styles.offerWrapper,
                    buttonClassName: styles.offerBannerButton
                  }, offerBanner))]
                }), hasCTA && /*#__PURE__*/_jsx("div", {
                  className: classnames(styles.cta, {
                    [styles.ctaStacked]: stackCTA
                  }),
                  children: renderCTA(cta, true)
                })]
              })]
            })
          })]
        })
      })
    })]
  });
  var renderStickyBanner = function renderStickyBanner() {
    var _ref2 = stickyBanner || {},
      text = _ref2.text,
      cta = _ref2.cta,
      align = _ref2.align,
      hideOnDesktop = _ref2.hideOnDesktop,
      background = _ref2.background,
      theme = _ref2.theme,
      stackSticky = _ref2.stackSticky,
      ignoreMaxHeight = _ref2.ignoreMaxHeight,
      stickyTypog = _ref2.stickyTypog,
      alignStickyText = _ref2.alignStickyText;
    text = text || '';
    cta = cta || {
      accessibilityLabel: '',
      newWindow: false,
      text: '',
      type: undefined,
      url: ''
    };
    align = align || 'right';
    hideOnDesktop = hideOnDesktop || false;
    background = background || Colors.colorWW100;
    theme = theme || 'darkBackground';
    var _cta = cta,
      buttonText = _cta.text,
      type = _cta.type,
      url = _cta.url,
      otherProps = _objectWithoutProperties(_cta, _excluded3);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Waypoint, {
        onEnter: handleStickyWaypointEnter,
        onLeave: handleStickyWaypointLeave
      }), /*#__PURE__*/_jsx(Theme, {
        theme: theme,
        children: /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.stickyBannerContainer, {
            [styles.hideOnDesktop]: hideOnDesktop,
            [styles.hideDrawer]: hideDrawer,
            [styles.drawerDropShadow]: hasStickyOfferBanner
          }),
          style: {
            bottom: stickyOffset,
            background: background
          },
          children: [/*#__PURE__*/_jsxs(Container, {
            className: styles.stickyBannerOuter,
            innerClassName: classnames(styles.stickyBanner, stackSticky ? styles.stackSticky : '', align ? styles[align] : ''),
            children: [/*#__PURE__*/_jsx(Text, {
              richText: true,
              className: classnames(styles.stickyText, ignoreMaxHeight ? styles.ignoreMaxHeight : '', alignStickyText ? styles[alignStickyText] : 'left'),
              typog: stickyTypog || 'subhead3',
              children: text
            }), hasStickyOfferBanner && /*#__PURE__*/_jsx(OfferBanner, _objectSpread({
              align: alignStickyText ? alignStickyText : undefined,
              className: classnames(styles.offer, hasStickyOfferBanner ? styles.updateMargin : ''),
              wrapperClassName: styles.offerWrapper
            }, stickyBanner.stickyOfferBanner)), /*#__PURE__*/_jsx("div", {
              className: stackSticky ? styles.adjustButtonMargin : '',
              children: cta && buttonText && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
                className: styles.stickyCta,
                type: type,
                url: url
              }, otherProps), {}, {
                children: /*#__PURE__*/_jsx(Text, {
                  richText: true,
                  textElement: "span",
                  typog: "bodycopy",
                  className: styles.ctaText,
                  children: buttonText
                })
              }))
            })]
          }), stickyBanner.enableCloseOption && /*#__PURE__*/_jsx("div", {
            className: styles.popupDrawer,
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: closeDrawer,
              className: styles.iconButton,
              "aria-label": "Click to close popup",
              icon: "close",
              size: "14px"
            })
          })]
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Waypoint, {
      onEnter: handleBannerWaypointEnter,
      onLeave: handleBannerWaypointLeave
    }), /*#__PURE__*/_jsxs(Theme, {
      theme: theme,
      children: [showPromoBanner && bannerContent, !(floatingCTA !== null && floatingCTA !== void 0 && floatingCTA.show) && (stickyBanner === null || stickyBanner === void 0 ? void 0 : stickyBanner.show) && renderStickyBanner(), (icon === null || icon === void 0 ? void 0 : icon.show) && (floatingCTA === null || floatingCTA === void 0 ? void 0 : floatingCTA.show) && /*#__PURE__*/_jsx(Waypoint, {
        onEnter: handleButtonWaypointEnter,
        onLeave: handleButtonWaypointLeave,
        topOffset: floatingCTA.waypointOffset,
        children: renderFloatingCTA((floatingCTA === null || floatingCTA === void 0 ? void 0 : floatingCTA.icon) || icon, iconTheme, innerBackgroundStyle, floatingCTA)
      })]
    })]
  });
};